import {Component, forwardRef} from "@angular/core";
import {SelectOptionsComponent} from "../../../framework/entity/select/options/select-options.component";
import {TranslateService} from "@ngx-translate/core";
import {KvdDisplayType} from "../order-processor.data";

@Component({
    selector: "wbo-kvd-display-type-select-options",
    templateUrl: "./kvd-display-type-select-options.component.html",
    providers: [{
        provide: SelectOptionsComponent,
        useExisting: forwardRef(() => KvdDisplayTypeSelectOptionsComponent),
        multi: true
    }]
})
export class KvdDisplayTypeSelectOptionsComponent extends SelectOptionsComponent {
    KvdDisplayType = KvdDisplayType;

    constructor(translateService: TranslateService) {
        super(translateService);
    }
}
